import React, { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import { Switch } from "react-router-dom";
import asyncComponent from "components/utility/async/AsyncComponent";
import AppliedRoute from "components/utility/route/AppliedRoute";

///prototype only -- profile page
const AsynProfilePrototype = asyncComponent(() => import("components/profile/ProfilePrototype"));
//production homepage
const AsyncHeader = lazy(() => import("components/header/HeaderStandalone"));
//prototype only
const AsyncContentPage = asyncComponent(() => import("components/page/content-page/ContentPage"));
//prototype only
const AsyncCollectionPage = asyncComponent(
	() => import("components/page/collection-page/CollectionPage")
);
//prototype only
const AsynContactUsContainerPrototype = asyncComponent(
	() => import("components/page/contact-us/ContactUsContainer")
);

const AsyncContactUsModal = asyncComponent(
	() => import("components/page/contact-us/UnauthenticatedContactUsModalContainer")
);
//prototype only
const AsyncOrderPrintedMaterialsrototype = asyncComponent(
	() => import("components/page/order-printed-materials/OrderPrintedMaterials")
);
//prototype only - sub pages for content pages
const AsyncContentPageSub = asyncComponent(
	() => import("components/page/content-page/ContentPageSub")
);

//production content/curated pages for sharing links
const AsyncContentPageActions = asyncComponent(
	() => import("components/page/content-page/ContentPageActions")
);
//production content/curated pages for sharing links
const AsyncThreeUp = asyncComponent(() => import("components/page/three-up/ThreeUpContainer"));
//production content/curated pages for sharing links
const AsyncContentPageShareableQuote = asyncComponent(
	() => import("components/page/content-page/ContentPageShareableQuote")
);
//production search page sharing links
const AsyncSearchPageActions = asyncComponent(
	() => import("components/search/client/SearchPageActions")
);
//production global search country selector
const AsyncSearchGlobal = asyncComponent(
	() => import("components/search/client/SearchGlobalCountrySelector")
);
//production content/ accordion drop down
const AsyncContentPageAccordionDropDown = asyncComponent(
	() => import("components/page/content-page/ContentPageAccordionDropDown")
);
//production collection page action button
const AsyncCollectionPageActions = asyncComponent(
	() => import("components/page/collection-page/CollectionPageActions")
);
//production footnotes
const AsyncContentPageFootnotes = asyncComponent(
	() => import("components/page/content-page/ContentPageFootnotes")
);
//production footnotes
const AsyncInformationalPopup = asyncComponent(
	() => import("components/utility/info-popup/InformationalPopup")
);
//production metadata
const AsyncMetaData = asyncComponent(
	() => import("components/page/content-page/ContentPageMetadataTooltip")
);
//production lightbox
const AsyncLightBox = asyncComponent(() => import("components/utility/lightbox/LightBox"));
//production orderMaterial
const AsyncPrintedMaterialInformationContainer = asyncComponent(
	() => import("components/page/order-printed-materials/PrintedMaterialInformationContainer")
);
//production PrintedMaterialsCartContainer
const PrintedMaterialsCartContainer = asyncComponent(
	() => import("components/page/order-printed-materials/PrintedMaterialsCartContainer")
);
//propduction collection nav
const AsynCollectionNav = asyncComponent(
	() => import("components/page/collection-page/CollectionPageSectionNavContainer")
);
// privacy policy/legal page
const AsyncLegalPage = asyncComponent(() => import("components/page/legal-page/LegalPage"));
//production profile page
const AsynProfile = asyncComponent(() => import("components/profile/ProfileStandAlone"));
//production secondary  header
const AsynSeondaryHeader = asyncComponent(
	() => import("components/header/HeaderSecondaryHeaderContainer")
);
//prototype only
const AsynErrorPagePrototype = asyncComponent(() => import("components/page/error-page/ErrorPage"));
//prototype only
const AsynPausePagePrototype = asyncComponent(() => import("components/page/pause-page/PausePage"));
// interstitial
const AsynInterstitial = asyncComponent(() => import("components/page/interstitial/Interstitial"));
// prototype only
const AsynNoAuthNav = asyncComponent(() => import("components/no-auth-nav/NoAuthNav"));
const AsynNoAuthNavXLink = asyncComponent(() => import("components/no-auth-nav/NoAuthNavXLink"));
// production contact us
const AsynContactUs = asyncComponent(() => import("components/page/contact-us/ContactUsAlone"));
//production  page
const AsynLogin = asyncComponent(
	() => import("components/page/access-and-auth/login-page/LoginPage")
);
//production  page
const AsynFirstLogin = asyncComponent(
	() => import("components/page/access-and-auth/first-login/FirstLogin")
);
//production page
const AsynHeaderTopPersistentBar = asyncComponent(
	() => import("components/header/HeaderTopPersistentBar")
);
//production page
const AsynHeaderBottomPersistentBar = asyncComponent(
	() => import("components/header/HeaderBottomPersistentBar")
);
//production  page
const AsynResetPassword = asyncComponent(
	() => import("components/page/access-and-auth/reset-password/ResetPassword")
);
//production  page
const AsynRegistration = asyncComponent(
	() => import("components/page/access-and-auth/registration/Registration")
);
//production  page
const AsynPopupNotification = asyncComponent(
	() => import("components/page/popup-notification/PopupNotification")
);
//production  page
const AsynIframePage = asyncComponent(() => import("components/page/iframe-page/IframePage"));
//production page
const AsyncSearchCallToActionBar = asyncComponent(
	() => import("components/search/client/SearchCallToActionBar")
);
//production page
const AsyncRelatedContentBlock = asyncComponent(
	() => import("components/utility/related-content-block/RelatedContentBlock")
);
//production page
const AsyncCampaignBackgroundTheme2 = asyncComponent(
	() => import("components/page/campaign/campaign-background/CampaignBackgroundThemeTwo")
);
//production page
const AsyncCampaignBackgroundTheme1 = asyncComponent(
	() => import("components/page/campaign/campaign-background/CampaignBackgroundThemeOne")
);

const AsyncCampaignCTABelt = asyncComponent(
	() => import("components/page/campaign/campaign-cta-belt/CampaignCTABelt")
);

const AsyncCampaignBanner = asyncComponent(
	() => import("components/page/campaign/campaign-banner/CampaignBannerPage")
);
//production page
const AsyncCampaignHeader = asyncComponent(
	() => import("components/page/campaign/campaign-header/CampaignHeader")
);
//production tabcordion page
const AsyncTabcordion = asyncComponent(
	() => import("components/page/campaign/tabcordion/TabcordionPage")
);

///////////////////////////Public Site////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////
//Non Content public prototype
const AsyncPublicFeatureRow = asyncComponent(
	() => import("components/public-site/page/feature-row/FeatureRow")
);
const AsyncPublicMaterialBoxDownload = asyncComponent(
	() => import("components/page/material-box/material-box-download/MaterialBoxDownload")
);
const AsyncPublicMaterialBoxFormDownload = asyncComponent(
	() =>
		import("components/page/material-box/material-box-gated-download/MaterialBoxGatedDownloadForm")
);
const AsyncMaterialBoxGatedEmail = asyncComponent(
	() => import("components/page/material-box/material-box-gated-email/MaterialBoxGatedEmail")
);

//Production page/////////////
//production homepage
const AsyncPublicHeader = lazy(() => import("components/public-site/header/HeaderStandalone"));
const AsyncPublicFooter = asyncComponent(() => import("components/public-site/footer/Footer"));
// production public page header banner
const AsyncPublicPageHeader = asyncComponent(
	() => import("components/public-site/page/public-page-header/PublicPageHeaderContainer")
);
// Navbar used on totn
const AsyncSimplePublicHeader = asyncComponent(
	() => import("components/simple-public-nav/SimplePublicNav")
);
// production media center
const AsyncCoveoContainer = asyncComponent(
	() => import("components/coveo-headless/CoveoContainer")
);
// page header
const AsyncLeftAlignedPageHeader = asyncComponent(
	() => import("components/page/left-aligned-page-header/LeftAlignedPageHeaderContainer")
);
const AsyncPublicHomepageRemembranceModal = asyncComponent(
	() => import("components/public-site/page/homepage-remembrance-modal/HomepageRemembranceModal")
);
//production document center
const AsyncDocumentCenter = asyncComponent(
	() => import("components/public-site/page/document-center/DocumentCenter")
);
const AsyncGeneralDocumentsDrawer = asyncComponent(
	() => import("components/public-site/page/document-center/GeneralDocumentsContainer")
);
const AsyncAudioPlayer = asyncComponent(
	() => import("components/public-site/page/audio-player/AudioPlayer")
);
// production announcements banner
const AsyncAnnouncementsContainer = asyncComponent(
	() => import("components/public-site/page/announcements/AnnouncementsContainer")
);
// public-site global splash page geolocated
const AsyncPublicGlobalSplashPage = asyncComponent(
	() => import("components/public-site/page/global-splash/GlobalSplash")
);
// public-site financial professional affirmation splash page
const AsyncPublicProfessionalAffirmationPage = asyncComponent(
	() => import("components/public-site/page/global-splash/ProfessionalAffirmationPage")
);
// public-site unkown audience type and location splash page
const AsyncPublicUnknownAudienceSplashPage = asyncComponent(
	() => import("components/public-site/page/global-splash/UnknownAudienceSplashPage")
);

const AsyncBBTitle = asyncComponent(() => import("components/bb-title/BBTitleContainerPage"));

const AsyncGenericLottie = asyncComponent(
	() => import("components/generic-lottie/GenericLottieContainer")
);

const AsyncOutPerformedAnimatedExhibit = asyncComponent(
	() => import("components/ddiff-animated-exhibit/OutperformedAnimatedExhibitPage")
);
const AsyncPeopleContainer = asyncComponent(
	() => import("components/people-container/PeopleContainerPage")
);
const AsyncCardCarouselContainer = asyncComponent(
	() => import("components/card-carousel/CardCarouselContainer")
);
const AsyncFullWidthMediaWithCardContainer = asyncComponent(
	() => import("components/full-width/FullWidthMediaWithCardContainer")
);

const AsyncLegacyStrategies = asyncComponent(
	() => import("components/legacy-strategies/LegacyStrategies")
);
const AsyncFastFacts = asyncComponent(() => import("components/fast-facts/FastFactsContainer"));
const AsyncDDiffResearchIsInOurDNA = asyncComponent(
	() => import("components/ddiff-research-in-dna/DDiffResearchIsInOurDNAContainer")
);
const AsyncDDiffLaureatesAnimatedExhibitContainer = asyncComponent(
	() => import("components/ddiff-laureates-animated-exhibit/DDiffLaureatesAnimatedExhibitContainer")
);

const AsyncPopupVideo = asyncComponent(() => import("components/popup-video/PopupVideoContainer"));
const AsyncAnimatedPremiumsExhibit = asyncComponent(
	() => import("components/ddiff-animated-exhibit/AnimatedPremiumsExhibitContainer")
);
const AsyncScrollExhibit = asyncComponent(
	() => import("components/scroll-exhibit/ScrollExhibitContainer")
);
const AsyncColumnCardContainer = asyncComponent(
	() => import("components/column-cards/ColumnCardContainer")
);

const AsyncExtendedCardCarousel = asyncComponent(
	() => import("components/extended-card-carousel/ExtendedCardCarouselContainer")
);

const AsyncEventTable = asyncComponent(
	() => import("components/events-table/EventsTableContainer")
);

const AsyncUIPlatformDToolTipDataAdapter = asyncComponent(
	() => import("components/ui-platform/DToolTipDataAdapter")
);

const AsyncInteractiveTimeline = asyncComponent(
	() => import("pages/interactive-timeline/InteractiveTimelineContainer")
);

const AsyncAudienceSelectorModalFromLink = asyncComponent(
	() => import("components/public-site/audience-sort/AudienceSelectorFromLink")
);

const AsyncProfessionalAffirmationSplashModal = asyncComponent(
	() => import("components/public-site/audience-sort/ProfessionalAffirmationSplashModal")
);
const AsyncInPageStickyNavigationContainer = asyncComponent(
	() => import("pages/InPageStickyNavigationContainer")
);
const AsyncStickyVerticalTabsContainer = lazy(
	() => import("components/sticky-vertical-tabs/StickyVerticalTabsContainer")
);

const Routes = ({ childProps }) => {
	return (
		<Switch>
			{childProps.view === "header" ? (
				<Suspense fallback={<div className="header-nav-placeholder"></div>}>
					<AppliedRoute path="*" component={AsyncHeader} props={childProps} />
				</Suspense>
			) : childProps.view === "content-page" ? (
				<AppliedRoute path="*" component={AsyncContentPage} props={childProps} />
			) : childProps.view === "collection-page" ? (
				<AppliedRoute path="*" component={AsyncCollectionPage} props={childProps} />
			) : childProps.view === "content-page-actions" ? (
				<AppliedRoute path="*" component={AsyncContentPageActions} props={childProps} />
			) : childProps.view === "content-page-shareable-quote" ? (
				<AppliedRoute path="*" component={AsyncContentPageShareableQuote} props={childProps} />
			) : childProps.view === "three-up" ? (
				<AppliedRoute path="*" component={AsyncThreeUp} props={childProps} />
			) : childProps.view === "search-page-actions" ? (
				<AppliedRoute path="*" component={AsyncSearchPageActions} props={childProps} />
			) : childProps.view === "search-global-country-selector" ? (
				<AppliedRoute path="*" component={AsyncSearchGlobal} props={childProps} />
			) : childProps.view === "accordion-drop-down" ? (
				<AppliedRoute path="*" component={AsyncContentPageAccordionDropDown} props={childProps} />
			) : childProps.view === "collection-page-actions" ? (
				<AppliedRoute path="*" component={AsyncCollectionPageActions} props={childProps} />
			) : childProps.view === "footnotes" ? (
				<AppliedRoute path="*" component={AsyncContentPageFootnotes} props={childProps} />
			) : childProps.view === "info-popup" ? (
				<AppliedRoute path="*" component={AsyncInformationalPopup} props={childProps} />
			) : childProps.view === "metadata" ? (
				<AppliedRoute path="*" component={AsyncMetaData} props={childProps} />
			) : childProps.view === "content-page-sub" ? (
				<AppliedRoute path="*" component={AsyncContentPageSub} props={childProps} />
			) : childProps.view === "lightbox" ? (
				<AppliedRoute path="*" component={AsyncLightBox} props={childProps} />
			) : childProps.view === "collection-nav" ? (
				<AppliedRoute path="*" component={AsynCollectionNav} props={childProps} />
			) : childProps.view === "legal-page" ? (
				<AppliedRoute path="*" component={AsyncLegalPage} props={childProps} />
			) : childProps.view === "profile" ? (
				<AppliedRoute path="*" component={AsynProfile} props={childProps} />
			) : childProps.view === "profile-prototype" ? (
				<AppliedRoute path="*" component={AsynProfilePrototype} props={childProps} />
			) : childProps.view === "secondary-header" ? (
				<AppliedRoute path="*" component={AsynSeondaryHeader} props={childProps} />
			) : childProps.view === "error-page-prototype" ? (
				<AppliedRoute path="*" component={AsynErrorPagePrototype} props={childProps} />
			) : childProps.view === "pause-page-prototype" ? (
				<AppliedRoute path="*" component={AsynPausePagePrototype} props={childProps} />
			) : childProps.view === "interstitial" ? (
				<AppliedRoute path="*" component={AsynInterstitial} props={childProps} />
			) : childProps.view === "no-auth-nav" ? (
				<AppliedRoute path="*" component={AsynNoAuthNav} props={childProps} />
			) : childProps.view === "no-auth-nav-xlink" ? (
				<AppliedRoute path="*" component={AsynNoAuthNavXLink} props={childProps} />
			) : childProps.view === "contact-us-container" ? (
				<AppliedRoute path="*" component={AsynContactUsContainerPrototype} props={childProps} />
			) : childProps.view === "contact-us-modal" ? (
				<AppliedRoute path="*" component={AsyncContactUsModal} props={childProps} />
			) : childProps.view === "contact-us" ? (
				<AppliedRoute path="*" component={AsynContactUs} />
			) : childProps.view === "top-persistent-bar" ? (
				<AppliedRoute path="*" component={AsynHeaderTopPersistentBar} props={childProps} />
			) : childProps.view === "bottom-persistent-bar" ? (
				<AppliedRoute path="*" component={AsynHeaderBottomPersistentBar} props={childProps} />
			) : childProps.view === "order-form-page" ? (
				<AppliedRoute path="*" component={AsyncOrderPrintedMaterialsrototype} props={childProps} />
			) : childProps.view === "first-login-modal" ? (
				<AppliedRoute path="*" component={AsynFirstLogin} props={childProps} />
			) : childProps.view === "reset-password" ? (
				<AppliedRoute path="*" component={AsynResetPassword} props={childProps} />
			) : childProps.view === "login-page" ? (
				<AppliedRoute path="*" component={AsynLogin} props={childProps} />
			) : childProps.view === "registration" ? (
				<AppliedRoute path="*" component={AsynRegistration} props={childProps} />
			) : childProps.view === "order-material" ? (
				<AppliedRoute
					path="*"
					component={AsyncPrintedMaterialInformationContainer}
					props={childProps}
				/>
			) : childProps.view === "order-form-drawer" ? (
				<AppliedRoute path="*" component={PrintedMaterialsCartContainer} props={childProps} />
			) : childProps.view === "popup-notification" ? (
				<AppliedRoute path="*" component={AsynPopupNotification} props={childProps} />
			) : childProps.view === "iframe-page" ? (
				<AppliedRoute path="*" component={AsynIframePage} props={childProps} />
			) : childProps.view === "search-call-to-action-bar" ? (
				<AppliedRoute path="*" component={AsyncSearchCallToActionBar} props={childProps} />
			) : childProps.view === "related-content-block" ? (
				<AppliedRoute path="*" component={AsyncRelatedContentBlock} props={childProps} />
			) : ///////public site//////////
			childProps.view === "public-feature-row" ? (
				<AppliedRoute path="*" component={AsyncPublicFeatureRow} props={childProps} />
			) : childProps.view === "public-header" ? (
				<Suspense
					fallback={
						<div className={`public-header-placeholder ${window.publicGlobalNav.theme}`}></div>
					}
				>
					<AppliedRoute path="*" component={AsyncPublicHeader} props={childProps} />
				</Suspense>
			) : childProps.view === "simple-public-global-nav" ? (
				<AppliedRoute path="*" component={AsyncSimplePublicHeader} props={childProps} />
			) : childProps.view === "public-footer" ? (
				<AppliedRoute path="*" component={AsyncPublicFooter} props={childProps} />
			) : childProps.view === "public-insight-connect-us" ? (
				<AppliedRoute path="*" component={AsyncPublicPageHeader} props={childProps} />
			) : childProps.view === "material-box-download" ? (
				<AppliedRoute path="*" component={AsyncPublicMaterialBoxDownload} props={childProps} />
			) : childProps.view === "material-box-gated-download" ? (
				<AppliedRoute path="*" component={AsyncPublicMaterialBoxFormDownload} props={childProps} />
			) : childProps.view === "homepage-remembrance-modal" ? (
				<AppliedRoute path="*" component={AsyncPublicHomepageRemembranceModal} props={childProps} />
			) : childProps.view === "document-center" ? (
				<AppliedRoute path="*" component={AsyncDocumentCenter} props={childProps} />
			) : childProps.view === "general-documents" ? (
				<AppliedRoute path="*" component={AsyncGeneralDocumentsDrawer} props={childProps} />
			) : childProps.view === "announcements-banner" ? (
				<AppliedRoute path="*" component={AsyncAnnouncementsContainer} props={childProps} />
			) : childProps.view === "material-box-gated-email" ? (
				<AppliedRoute path="*" component={AsyncMaterialBoxGatedEmail} props={childProps} />
			) : childProps.view === "tabcordion" ? (
				<AppliedRoute path="*" component={AsyncTabcordion} props={childProps} />
			) : childProps.view === "campaign-header" ? (
				<AppliedRoute path="*" component={AsyncCampaignHeader} props={childProps} />
			) : childProps.view === "campaign-background-theme-two" ? (
				<AppliedRoute path="*" component={AsyncCampaignBackgroundTheme2} props={childProps} />
			) : childProps.view === "campaign-background-theme-one" ? (
				<AppliedRoute path="*" component={AsyncCampaignBackgroundTheme1} props={childProps} />
			) : childProps.view === "campaign-cta-belt" ? (
				<AppliedRoute path="*" component={AsyncCampaignCTABelt} props={childProps} />
			) : childProps.view === "campaign-banner" ? (
				<AppliedRoute path="*" component={AsyncCampaignBanner} props={childProps} />
			) : childProps.view === "left-aligned-page-header" ? (
				<AppliedRoute path="*" component={AsyncLeftAlignedPageHeader} props={childProps} />
			) : childProps.view === "coveo-search" ? (
				<AppliedRoute path="*" component={AsyncCoveoContainer} props={childProps} />
			) : childProps.view === "audio-player" ? (
				<AppliedRoute path="*" component={AsyncAudioPlayer} props={childProps} />
			) : childProps.view === "splash-page-modal" ? (
				<AppliedRoute path="*" component={AsyncPublicGlobalSplashPage} props={childProps} />
			) : childProps.view === "professional-affirmation-splash-page" ? (
				<AppliedRoute
					path="*"
					component={AsyncPublicProfessionalAffirmationPage}
					props={childProps}
				/>
			) : childProps.view === "unknown-audience-splash-page" ? (
				<AppliedRoute
					path="*"
					component={AsyncPublicUnknownAudienceSplashPage}
					props={childProps}
				/>
			) : childProps.view === "people-container" ? (
				<AppliedRoute path="*" component={AsyncPeopleContainer} props={childProps} />
			) : childProps.view === "bb-title" ? (
				<AppliedRoute path="*" component={AsyncBBTitle} props={childProps} />
			) : childProps.view === "generic-lottie" ? (
				<AppliedRoute path="*" component={AsyncGenericLottie} props={childProps} />
			) : childProps.view === "ddiff-outperformed" ? (
				<AppliedRoute path="*" component={AsyncOutPerformedAnimatedExhibit} props={childProps} />
			) : childProps.view === "card-carousel-container" ? (
				<AppliedRoute path="*" component={AsyncCardCarouselContainer} props={childProps} />
			) : childProps.view === "full-width-media-with-card" ? (
				<AppliedRoute
					path="*"
					component={AsyncFullWidthMediaWithCardContainer}
					props={childProps}
				/>
			) : childProps.view === "fast-facts" ? (
				<AppliedRoute path="*" component={AsyncFastFacts} props={childProps} />
			) : childProps.view === "ddiff-research-is-in-our-dna" ? (
				<AppliedRoute path="*" component={AsyncDDiffResearchIsInOurDNA} props={childProps} />
			) : childProps.view === "legacy-strategies" ? (
				<AppliedRoute path="*" component={AsyncLegacyStrategies} props={childProps} />
			) : childProps.view === "popup-video" ? (
				<AppliedRoute path="*" component={AsyncPopupVideo} props={childProps} />
			) : childProps.view === "laureates-animated-exhibit" ? (
				<AppliedRoute
					path="*"
					component={AsyncDDiffLaureatesAnimatedExhibitContainer}
					props={childProps}
				/>
			) : childProps.view === "ddiff-premiums-animated-exhibit" ? (
				<AppliedRoute path="*" component={AsyncAnimatedPremiumsExhibit} props={childProps} />
			) : childProps.view === "scroll-exhibit" ? (
				<AppliedRoute path="*" component={AsyncScrollExhibit} props={childProps} />
			) : childProps.view === "extended-card-carousel-container" ? (
				<AppliedRoute path="*" component={AsyncExtendedCardCarousel} props={childProps} />
			) : childProps.view === "column-card-container" ? (
				<AppliedRoute path="*" component={AsyncColumnCardContainer} props={childProps} />
			) : childProps.view === "event-table" ? (
				<AppliedRoute path="*" component={AsyncEventTable} props={childProps} />
			) : childProps.view === "ui-platform-dtooltip" ? (
				<AppliedRoute path="*" component={AsyncUIPlatformDToolTipDataAdapter} props={childProps} />
			) : childProps.view === "interactive-timeline" ? (
				<AppliedRoute path="*" component={AsyncInteractiveTimeline} props={childProps} />
			) : childProps.view === "in-page-sticky-navigation" ? (
				<AppliedRoute
					path="*"
					component={AsyncInPageStickyNavigationContainer}
					props={childProps}
				/>
			) : childProps.view === "audience-selector-modal-from-link" ? (
				<AppliedRoute path="*" component={AsyncAudienceSelectorModalFromLink} props={childProps} />
			) : childProps.view === "professional-affirmation-splash-modal" ? (
				<AppliedRoute
					path="*"
					component={AsyncProfessionalAffirmationSplashModal}
					props={childProps}
				/>
			) : childProps.view === "sticky-vertical-tabs" ? (
				<AppliedRoute path="*" component={AsyncStickyVerticalTabsContainer} props={childProps} />
			) : null}
		</Switch>
	);
};

Routes.propTypes = {
	childProps: PropTypes.object
};

export default Routes;
